module.exports = __webpack_public_path__ + "static/media/texture (18).63a4c799.jpg";